import { render } from "./CartConfimOrderComponent.vue?vue&type=template&id=253c017f&scoped=true"
import script from "./CartConfimOrderComponent.vue?vue&type=script&lang=js"
export * from "./CartConfimOrderComponent.vue?vue&type=script&lang=js"

import "./CartConfimOrderComponent.vue?vue&type=style&index=0&id=253c017f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253c017f"]])

export default __exports__